import { FieldArray } from "formik";
import TitleTooltip from "../../../components/helpers/TitleTooltip";
import ErrorMessage from "../../../components/helpers/ErrorMessage";
import Message from 'rsuite/Message';
import 'rsuite/Message/styles/index.css';
import MaskedInput from 'rsuite/MaskedInput';
import 'rsuite/Input/styles/index.css';
import 'rsuite/InputGroup/styles/index.css';
export default function Step5({
    formik,
    totalW,
    totalM
}) {

    const opc = {
        mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        placeholder: '11-1111-1111'
    };

    return (
        <div className="w-100">
            <div className="d-flex pb-8 pb-lg-10 justify-content-between">
                <div>
                    <h2 className="fw-bold text-gray-900" tabIndex={-1}>Activar
                        Notificaciones</h2>
                    <div className="text-muted fw-semibold fs-6">Si se desean, habilitar
                        notificaciones.
                    </div>
                </div>
                <div>
                    <h3 className="fw-bold text-gray-900"> ${formik.values.costo} <span
                        className={"fs-9 text-gray-600"}
                        style={{paddingTop: "0.3rem"}}>MXN</span></h3>
                </div>
            </div>
            {
                (totalW.length === 0 && totalM.length === 0) && <Message>
                    <strong>Info!</strong> Paquete sin notificaciones
                </Message>
            }
            {
               totalW && totalW.length > 0 && <>
                    <div className="card card-flush card-px-0">
                            <FieldArray
                                name={'telefonos'}
                                render={(arrayHelper) => {
                                    return(
                                        <>
                                            <div className="card-header justify-content-between">
                                                <div className="card-toolbar">
                                                    <TitleTooltip title={"Máximo " + totalW.length} placement={"top"}>
                                                        <button type="button" className="btn p-0 text-active-primary text-hover-primary"
                                                                onClick={() =>
                                                                    arrayHelper.push({telefono : ""})
                                                                }
                                                                disabled={formik.values.telefonos.length === totalW.length}
                                                        >
                                                            <i className="ki-duotone ki-message-add fs-2qx">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                                <span className="path3"></span>
                                                            </i>
                                                            WhatsApp
                                                        </button>
                                                    </TitleTooltip>
                                                </div>
                                            </div>
                                            <div className="separator"></div>
                                            <div className="card-body">
                                                <div className={'row'}>
                                                    {
                                                         formik.values.telefonos.map((m, index) => {
                                                            return(
                                                                <div key={index} className={"col-md"}>
                                                                    <div className={"form-floating"}>
                                                                        <MaskedInput
                                                                            className="form-control form-control-solid"
                                                                            id={`telefonos.${index}.telefono`}
                                                                            name={`telefonos.${index}.telefono`}
                                                                            value={m.telefono}
                                                                            mask={opc.mask}
                                                                            guide={true}
                                                                            showMask={false}
                                                                            keepCharPositions={false}
                                                                            placeholder={opc.placeholder}
                                                                            style={{ width: 'auto' }}
                                                                            onChange={(value) => formik.setFieldValue(`telefonos.${index}.telefono`, value)}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <label htmlFor={`telefonos.${index}.telefono`} className={"text-gray-700"}>Teléfono
                                                                            movil</label>
                                                                    </div>
                                                                    <ErrorMessage name={`telefonos.${index}.telefono`}/>
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    );
                                }}
                            />

                    </div>
                </>
            }
            {
              totalM && totalM.length > 0 && <>
                    <div className="card card-flush card-px-0">
                            <FieldArray
                                name={"correos"}
                                render={(arrayHelper) => {
                                    return(
                                        <>
                                            <div className="card-header justify-content-between">
                                                <div className="card-toolbar">
                                                    <TitleTooltip title={"Máximo " + totalM.length} placement={"top"}>
                                                        <button type="button" className="btn p-0 text-active-primary text-hover-primary"
                                                                onClick={() =>
                                                                    arrayHelper.push({correo: ""})
                                                                }
                                                                disabled={formik.values.correos.length === totalM.length}
                                                        >
                                                            <i className="ki-duotone ki-message-add fs-2qx">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                                <span className="path3"></span>
                                                            </i>
                                                            Mail
                                                        </button>
                                                    </TitleTooltip>
                                                </div>
                                            </div>
                                            <div className="separator"></div>
                                            <div className="card-body">
                                                <div className={"row"}>
                                                    {
                                                         formik.values.correos.map((correo, index) => {
                                                            return(
                                                                <div key={index} className={"col-md-4"}>
                                                                    <div className={"form-floating"}>
                                                                        <input
                                                                            type={'email'}
                                                                            className="form-control form-control-solid"
                                                                            id={`correos.${index}.correo`}
                                                                            name={`correos.${index}.correo`}
                                                                            placeholder="Mail #1"
                                                                            value={correo.correo}
                                                                            onChange={formik.handleChange}
                                                                        />
                                                                        <label htmlFor={`correos.${index}.correo`} className={"text-gray-700"}>Mail #{index + 1}</label>
                                                                    </div>
                                                                    <ErrorMessage name={`correos.${index}.correo`}/>
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    );
                                }}
                            />
                    </div>
                </>
            }
        </div>
    );
}
